export const metasInitialState = {
    // Get/All
    metas: [],
    isFetchingMetas: false,

    // Create
    isUploadingMeta: false,

    // Delete
    isDeletingMeta: false,

    // Edit
    isUpdatingMeta: false,

    error: null
}
